"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVesselTypeLabel = exports.normalizeVesselType = void 0;
var const_1 = require("../const");
/**
 * Normalizes a vessel type value coming from various sources (codes or labels)
 * into a canonical code value: 'MY' or 'SY'.
 * If the input cannot be recognized, returns the original value unchanged.
 */
var normalizeVesselType = function (value) {
    var v = (value || '').trim().toUpperCase();
    if (v === 'MY' || v === 'MOTOR YACHT')
        return 'MY';
    if (v === 'SY' || v === 'SAIL YACHT')
        return 'SY';
    return value;
};
exports.normalizeVesselType = normalizeVesselType;
/**
 * Returns the human-readable label for a vessel type value.
 * Accepts either codes ('MY'|'SY') or labels; falls back to the input if unknown.
 */
var getVesselTypeLabel = function (value) {
    var code = (0, exports.normalizeVesselType)(value);
    var found = const_1.YachtType.find(function (y) { return y.id === code; });
    return found ? found.title : value || '-';
};
exports.getVesselTypeLabel = getVesselTypeLabel;
//# sourceMappingURL=vesselType.js.map